/**
 * @file index.tsx
 *
 * @fileoverview Renders the organization search Meta tags.
 */
import Head from 'next/head';
import React, { useMemo } from 'react';
import { OG_IMAGE_META_NAME } from '~/jobiqo/components/Metatag/MetatagDefault';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface OrganizationSearchMetatagsProps {
  /**
   * List of jobs.
   */
  organizationProfiles: any;
}

export default function OrganizationSearchMetatags({
  organizationProfiles,
}: OrganizationSearchMetatagsProps) {
  const { ORGANIZATIONS } = useFrontendConfig();
  const SEOShareImage = useMemo(
    () => organizationProfiles?.seoSearchContent?.shareImage,
    [organizationProfiles?.seoSearchContent?.shareImage],
  );

  return (
    <Head>
      {ORGANIZATIONS.SEO.NO_INDEX_EMPTY_PAGE &&
        organizationProfiles?.pages?.length === 0 && (
          <meta name="robots" content="noindex" />
        )}
      {SEOShareImage && (
        <meta
          key={OG_IMAGE_META_NAME}
          name={OG_IMAGE_META_NAME}
          property={OG_IMAGE_META_NAME}
          content={SEOShareImage.url}
        />
      )}
    </Head>
  );
}
